/**
 * AI-TOGGLE
 * Switch of an AI feature : same shape as the toggle button, the track takes the animated gradient of the AI skin when on
 * and the wand replaces the check in the circle
 */
import { faWandMagicSparkles } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

interface OwnProps {
  isActive: boolean
  label: string
  onToggle: () => void
}

function AiToggle(props: OwnProps) {
  return (
    <div className="flex" style={{ alignItems: "center", gap: 8 }}>
      <div className={"toggle-button _hover" + (props.isActive ? " _animated" : "")} onClick={props.onToggle}>
        <div className={"flex toggle-button-circle" + (props.isActive ? " toggle-button-active" : "")}>
          {props.isActive && <FontAwesomeIcon icon={faWandMagicSparkles} style={{ fontSize: 11 }} />}
        </div>
      </div>
      <span
        className={"text-sm " + (props.isActive ? "_animated" : "grey-t")}
        style={
          props.isActive ? { backgroundClip: "text", WebkitBackgroundClip: "text", color: "transparent" } : undefined
        }>
        {props.label}
      </span>
    </div>
  )
}

export default AiToggle
